export const SHOW = 'open';
export const HIDE = 'close';
export const DIALOG = 'Dialog';
